import React from "react";
import { Autocomplete, TextField } from '@mui/material';

import DataPickerAtualizado from "../../../components/DataPickerAtualizado";

import "./styles.css";

export default function Formulario(props) {
  const {
    tabelas,
    vetorExames,
    setConvenio,
    setCod_exame,
    dataInicial,
    setDataInicial,
    dataFinal,
    setDataFinal 
  } = props;

  return (
    <div className="container-formulario-mapeamento-exames">
      <div className="container-campos-precos-exames">
        <div className="filtro-item">
          <DataPickerAtualizado
            labelName="Data inicial"
            data={dataInicial}
            setData={setDataInicial}
            sx={{ width: "100%" }}
          />
        </div>
        <div className="filtro-item">
          <DataPickerAtualizado
            labelName="Data final"
            data={dataFinal}
            setData={setDataFinal}
            sx={{ width: "100%" }}
          />
        </div>
        <div className="filtro-item">
          <Autocomplete
            id="select-exames-dna"
            onChange={(e, newValue) => {
              if (newValue) {
                setCod_exame(newValue.cod_exame);
              }
            }}
            options={vetorExames}
            getOptionLabel={(option) => option.cod_exame}
            fullWidth
            renderInput={(params) => <TextField {...params} label="Exames" variant="outlined" />}
          />
        </div>
        <div className="filtro-item">
          <Autocomplete
            id="select-tables-dna"
            onChange={(e, newValue) => {
              if (newValue) {
                setConvenio(newValue.convenio);
              }
            }}
            options={tabelas}
            getOptionLabel={(option) => option.convenio}
            fullWidth
            renderInput={(params) => <TextField {...params} label="Tabelas" variant="outlined" />}
          />
        </div>
      </div>
    </div>
  )
}
